
// Router.ts
import { Navigate, Route, BrowserRouter as Router, Routes } from 'react-router-dom';

import './App.css';
import './responsive.css';
import './welcome-responsive.css';
import './signin-responsive.css';
import './signup-responsive.css';
import './verification-email-resend-responsive.css';
import './password-recovery-responsive.css';

// Screens
import { CameraPreview } from './main/screens/CameraPreview';
import { CollectorDetails } from './main/screens/CollectorDetails';
import { Balance } from './main/screens/CSD/Balance';
import { CashOutResult } from './main/screens/CSD/CashOutResult';
import { CustomerConfirmation } from './main/screens/CSD/CustomerConfirmation';
import { RepresentativeConfirmation } from './main/screens/CSD/RepresentativeConfirmation';
import { SetStore } from './main/screens/CSD/SetStore';
import { WelcomeCSD } from './main/screens/CSD/WelcomeCSD';
import { Dashboard } from './main/screens/Dashboard';
import { EmailVerification } from './main/screens/EmailVerification';
import { EvianSweepstakesForm } from './main/screens/evian/EvianRegister';
import { Home } from './main/screens/Home';
import { PasswordRecovery } from './main/screens/PasswordRecovery';
import { SignIn } from './main/screens/SignIn';
import { SignUp } from './main/screens/SignUp';
import { VerificationEmailResend } from './main/screens/VerificationEmailResend';
import { Welcome } from './main/screens/Welcome';
import { EvianLeaderBoard } from './main/screens/evian/EvianLeaderBoard';
import { EvianQRScreen } from './main/screens/evian/EvianQRScreen';
import { EvianRules } from './main/screens/evian/EvianRules';
import { EvianPrivacy } from './main/screens/evian/EvianPrivacy';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/redemption-cash-3da5vj9xb2z/set-store" element={<SetStore />} />
        <Route path="/redemption-cash-3da5vj9xb2z/welcome" element={<WelcomeCSD />} />
        <Route path="/redemption-cash-3da5vj9xb2z/balance" element={<Balance />} />
        <Route
          path="/redemption-cash-3da5vj9xb2z/representative-confirmation"
          element={<RepresentativeConfirmation />}
        />
        <Route path="/redemption-cash-3da5vj9xb2z/customer-confirmation" element={<CustomerConfirmation />} />
        <Route path="/redemption-cash-3da5vj9xb2z/cash-out-result" element={<CashOutResult />} />

        <Route path="/" element={<Navigate replace to="/welcome" />} />
        <Route path="/welcome" element={<Welcome />} />
        <Route path="/sign-in" element={<SignIn />} />
        <Route path="/sign-up" element={<SignUp />} />
        <Route path="/email-verification" element={<EmailVerification />} />
        <Route path="/password-recovery" element={<PasswordRecovery />} />
        <Route path="/email-verification-resend" element={<VerificationEmailResend />} />

        <Route path="/evian-f1" element={<EvianSweepstakesForm />} />
        <Route path="/evian-f1/leaderboard" element={<EvianLeaderBoard />} />
        <Route path="/evian-f1/qr" element={<EvianQRScreen />} />
        <Route path="/evian-f1/rules" element={<EvianRules />} />
        <Route path="/evian-f1/privacy" element={<EvianPrivacy />} />

        <Route path="/home" element={<Home />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/preview/:id" element={<CameraPreview />} />
        <Route path="/collector/:id" element={<CollectorDetails />} />
      </Routes>
    </Router>
  );
}

export default App;
